import extensionLoader from './extension-loader';
import translationLoader from './translations-loader';

export default {
  extensionLoader,
  translationLoader,
};
